import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { KeycloakSessionService } from '../auth/keycloak-session.service';

/** statusText of the synthetic 401 raised by AuthInterceptor, so ErrorsInterceptor does not handle it twice. */
export const SESSION_EXPIRED_STATUS_TEXT = 'Session expired';

let loginRedirectInFlight = false;

export function sessionExpiredError(url: string): HttpErrorResponse {
  return new HttpErrorResponse({ status: 401, url, statusText: SESSION_EXPIRED_STATUS_TEXT });
}

/**
 * Drops the local session and sends the user to the login page. Several requests failing together
 * (parallel 401s, parallel dropped requests) trigger a single navigation.
 */
export function expireSession(keycloakSession: KeycloakSessionService, router: Router): void {
  keycloakSession.clearSession();

  if (loginRedirectInFlight || router.url?.startsWith('/login')) {
    return;
  }

  loginRedirectInFlight = true;
  Promise.resolve(router.navigate(['login'], { queryParams: { reason: 'session-expired' } }))
    .catch(() => false)
    .finally(() => {
      loginRedirectInFlight = false;
    });
}
